module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/plan_waso_location@2x-2ddbc7c88241461c8186be523487586e.webp";